import { type RPPDomain } from '@retailer-platform/dashboard/core'
import { AdminNavEntryPointV3, NavEntryPointV3 } from '@retailer-platform/dashboard/routing'
import { marketingToolingAdminRouter } from './routing/marketingToolingAdminRouter'
import {
  marketingToolingScopedRouter,
  marketingToolingSegmentLibraryRouter,
  marketingToolingUnsubscribeListRouter,
} from './routing/marketingToolingScopedRouter'
import { type DomainMessages } from './utils/domain/intl'
import { routes } from './routing/routes'
import { type DomainAccessControlConfig } from './utils/domain/accessControl'
import { marketingToolingAdminAccessControl } from './access-control/marketingToolingAdminAccess.configuration'
import { marketingToolingAccessControl } from './access-control/marketingToolingAccess.configuration'
import { marketingToolingSegmentLibraryAccessControl } from './access-control/marketingToolingSegmentLibraryAccess.configuration'
import { standaloneUnsubscribeListsAccessControl } from './access-control/standaloneUnsubscribeListsAccess.configuration'

const definition: RPPDomain<typeof routes, DomainMessages, DomainAccessControlConfig> = {
  id: 'marketing-tooling',
  totem: {
    tool: 'marketing-tooling-dashboard-tool',
  },
  routes,
  translations: {},
  lazyTranslations: {
    EN_US: () => import('./translations/en-US.json'),
    // Uncomment to lazy load your domain's foreign dictionaries
    // ES_ES: () => import('./translations/es-ES.json'),
    // FR_FR: () => import('./translations/fr-FR.json'),
  },
  // When adding a router, its route content must be wrapped in
  // MarketingToolingClickTrackingProvider (see routing/*.tsx) or the surface records
  // no click/view events. src/routing/__tests__/routerTrackingCoverage.spec.ts fails
  // CI if a router is missing the wrap.
  routers: {
    admin: [marketingToolingAdminRouter],
    partnerScoped: [
      marketingToolingScopedRouter,
      marketingToolingSegmentLibraryRouter,
      marketingToolingUnsubscribeListRouter,
    ],
  },
  navigationEntries: [
    {
      attachToV3: NavEntryPointV3.StorefrontPro,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Manage marketing campaigns for promotions and offers',
          route: 'app-marketing-tooling-campaigns',
          subRoutes: [
            'app-marketing-tooling-campaigns-create',
            'app-marketing-tooling-campaigns-edit',
          ],
          labelId: 'admin.marketing.tooling.navigation.label',
          accessControl: marketingToolingAccessControl,
          positionNavV3: 0,
        },
        {
          type: 'item',
          llmDescription: 'Browse and manage saved targeting segments',
          route: 'app-marketing-tooling-segment-library',
          labelId: 'marketingTooling.navigation.segmentLibrary.label',
          accessControl: marketingToolingSegmentLibraryAccessControl,
          positionNavV3: 1,
        },
        {
          type: 'item',
          llmDescription: 'Manage the standalone unsubscribe list for CRM sends',
          route: 'app-marketing-tooling-unsubscribe-list',
          labelId: 'marketingTooling.navigation.unsubscribeList.label',
          accessControl: standaloneUnsubscribeListsAccessControl,
          positionNavV3: 2.5,
        },
      ],
    },
    {
      attachToV3: NavEntryPointV3.Storefront,
      subNavItems: [
        {
          type: 'item',
          llmDescription: 'Manage marketing campaigns for promotions and offers',
          route: 'app-marketing-tooling-campaigns',
          subRoutes: [
            'app-marketing-tooling-campaigns-create',
            'app-marketing-tooling-campaigns-edit',
          ],
          labelId: 'admin.marketing.tooling.navigation.label',
          accessControl: marketingToolingAccessControl,
          positionNavV3: 0,
        },
        {
          type: 'item',
          llmDescription: 'Browse and manage saved targeting segments',
          route: 'app-marketing-tooling-segment-library',
          labelId: 'marketingTooling.navigation.segmentLibrary.label',
          accessControl: marketingToolingSegmentLibraryAccessControl,
          positionNavV3: 1,
        },
      ],
    },
  ],
  adminNavigationEntries: [
    {
      attachToV3: AdminNavEntryPointV3.Marketplace,
      subNavItems: [
        {
          route: 'app-admin-marketing-tooling-campaigns',
          subRoutes: [
            'app-admin-marketing-tooling-campaigns-create',
            'app-admin-marketing-tooling-campaigns-edit',
          ],
          labelId: 'admin.marketing.tooling.navigation.label',
          accessControl: marketingToolingAdminAccessControl,
          positionNavV3: 1,
        },
      ],
    },
  ],
}

export default definition
